import { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import {
  AbsoluteCenter,
  Box,
  Divider,
  Heading,
  VStack,
} from '@chakra-ui/react';
import { EvaluationEvent } from '@keyops-cep/api-client';

import {
  ReadOnlyInputField,
  ValidatedInputField,
  ValidatedRadioField,
} from '../../../components/InputComponents';
import i18n from '../../../utils/i18n';
import { EvaluationEventEditFormData } from '../evaluation-event-edit-form-utils';

type DetailsSectionProps = {
  control: Control<EvaluationEventEditFormData>;
  register: UseFormRegister<EvaluationEventEditFormData>;
  errors: FieldErrors<EvaluationEventEditFormData>;
  eventData: EvaluationEvent;
};

const DetailsSection = ({
  control,
  register,
  errors,
  eventData,
}: DetailsSectionProps) => {
  return (
    <>
      <Box position="relative" padding="10">
        <Divider />
        <AbsoluteCenter bg="white" px="4">
          <Heading size="md">
            {i18n.t('evaluationEvent.form.details.title')}
          </Heading>
        </AbsoluteCenter>
      </Box>
      <VStack spacing={4} align="stretch" mb={6}>
        <ReadOnlyInputField
          label={i18n.t('evaluationEvent.form.details.fields.id')}
          value={eventData.externalId}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.details.fields.name')}
          registerProps={register('name')}
          error={errors.name}
        />
        <ReadOnlyInputField
          label={i18n.t('evaluationEvent.form.details.fields.status')}
          value={eventData.status}
        />
        <ReadOnlyInputField
          label={i18n.t('evaluationEvent.form.details.fields.acceptResponses')}
          value={eventData.shouldAcceptResponses ? 'Yes' : 'No'}
        />
        <ValidatedRadioField
          name="language"
          control={control}
          label={i18n.t('evaluationEvent.form.details.fields.language')}
          error={errors.language}
          options={[
            { value: 'en', label: 'English' },
            { value: 'fr', label: 'French' },
          ]}
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.details.fields.startDate')}
          registerProps={register('startDate')}
          error={errors.startDate}
          type="datetime-local"
        />
        <ValidatedInputField
          label={i18n.t('evaluationEvent.form.details.fields.endDate')}
          registerProps={register('endDate')}
          error={errors.endDate}
          type="datetime-local"
        />
        <ReadOnlyInputField
          label={i18n.t('evaluationEvent.form.details.fields.users')}
          value={
            eventData.users
              ? eventData.users.map((user) => user.displayName).join(', ')
              : '<None specified>'
          }
        />
        <ReadOnlyInputField
          label={i18n.t('evaluationEvent.form.details.fields.department')}
          value={eventData.department}
        />
        <ReadOnlyInputField
          label={i18n.t('evaluationEvent.form.details.fields.format')}
          value={eventData.format}
        />
      </VStack>
    </>
  );
};

export default DetailsSection;
